import React from 'react';
import { AccentColor } from 'helpers/AccentColorHelper';
import { browserHistory } from 'react-router';

export default class PayWall extends React.Component {
  UNSAFE_componentWillMount() {
    // Rerender paywall every 1000ms. We can change this if we have performance issues
    const intervalId = setInterval(() => this.timer(), 2500);
    this.setState({ intervalId, counter: 0 });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  timer() {
    if (!this.state) return;

    // cycle counter between 0 and 1
    let counter = (this.state.counter + 1) % 2;
    this.setState({ counter });
  }

  getDom() {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: '501',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          display: 'flex',
        }}
      >
        <div
          style={{
            margin: 'auto',
            width: '60%',
            backgroundColor: '#fff',
            padding: '30px',
            border: `1px solid ${AccentColor()}`,
            textAlign: 'center',
            borderRadius: '5px',
            display: 'initial',
          }}
        >
          <h2>Account Disabled</h2>
          <h4>
            Thank you for using yuhu! Your trial period has ended. In order to continue using yuhu
            please update your billing information.
          </h4>
          <button
            type="button"
            className="link-button"
            onClick={() => browserHistory.push('/companies/billing')}
          >
            <h4 style={{ marginTop: '20px' }}>Update Billing Details</h4>
          </button>
        </div>
      </div>
    );
  }

  shouldShowPaywal() {
    const { currentRoute, active } = this.props;

    // Only show paywall if active is set as false and we're not currently
    // viewing the billing page
    return (
      active === false && currentRoute !== '/companies/billing' && currentRoute !== '/companies'
    );
  }

  render() {
    if (!this.shouldShowPaywal()) return <span />;

    // Force paywall DOM to rerender in attempt to avoid getting around paywall easily
    if (this.state.counter === 0) {
      return <div>{this.getDom()}</div>;
    } else {
      return this.getDom();
    }
  }
}
